import { render, staticRenderFns } from "./AppContentQuestionMemberAnswered.vue?vue&type=template&id=474836d9&scoped=true&"
import script from "./AppContentQuestionMemberAnswered.vue?vue&type=script&lang=js&"
export * from "./AppContentQuestionMemberAnswered.vue?vue&type=script&lang=js&"
import style0 from "./AppContentQuestionMemberAnswered.vue?vue&type=style&index=0&id=474836d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474836d9",
  null
  
)

export default component.exports